module.exports = __webpack_public_path__ + "static/media/about_us.d82c47ae.webp";